import { push } from 'connected-react-router'
import { getAuthToken } from '../../../services/authService';
import { removeCookie } from '../../../services/clientService';
import { getRequest, postRequest } from '../../../services/requestService';
import { buildLoginPageUrl } from '../../../services/urlBuilderService';
import * as types from './types';
import { refreshStats } from '../Jobs/actions';
import { getTrackingParams, setUserProperties } from '../../../services/analyticsService';
export function setUserDetails(userDetails, additionalParams = {}) {
  return {
    type: types.SET_USER_DETAILS,
    payload: { isAuthLoading: false, userDetails, ...additionalParams }
  }
}

/**
 * Fetch the user details and store them in Redux
 * This would work only if the user has JWT token stored in their cookie
 */
export const getUserData = (callback) => async dispatch => {
  dispatch({ type: types.SET_USER_DETAILS, payload: { isAuthLoading: true } })
  const authToken = getAuthToken();
  if (!authToken) return;

  try {
    const res = await postRequest(
      'auth/get-user-data',
      {
        trackingParams: getTrackingParams()
      },
      {
        headers: {
          'x-access-token': getAuthToken(),
        },
      },
    );
    if (res?.data?.userDetails) {
      setUserProperties(res.data.userDetails);
    }
    callback && callback(!!res.data.userDetails)


    dispatch(setUserDetails(res.data.userDetails, res.data))
    dispatch(refreshStats())
  }
  catch (e) {
    dispatch({ type: types.SET_USER_DETAILS, payload: { isAuthLoading: false } })
    removeCookie('x-access-token');
    dispatch(push(buildLoginPageUrl()))

  }
}

export const updateResume = (updatedResume) => async dispatch => {
  const formData = { resumeId: updatedResume._id, ...updatedResume }
  delete formData._id;
  const res = await postRequest('resume/update', formData)
  dispatch(setResume(res.data.resume))
}

/**
 * This creates or updates an existing resume
 */
export const setResume = (updatedResume) => (dispatch, getState) => {
  let exists = false
  let resumeFiles = getState().AuthReducer.userDetails.resumeFiles.map(existingResume => {
    if (existingResume._id === updatedResume._id) {
      exists = true;
      return updatedResume;
    }

    return existingResume
  })
  if (!exists) {
    resumeFiles.push(updatedResume)
  }

  if (updatedResume.isPrimary) {
    resumeFiles = resumeFiles.map(resume => {
      if (resume._id !== updatedResume._id) {
        resume.isPrimary = false;
      }

      return resume;
    })
  }

  const updatedUser = getState().AuthReducer.userDetails;
  updatedUser.resumeFiles = [...resumeFiles]
  dispatch({
    type: types.SET_RESUME,
    payload: { userDetails: updatedUser }
  })
}